import { AuthGuard, redirectUnauthorizedTo } from '@angular/fire/auth-guard';
import { Routes } from '@angular/router';
import { EmptyComponent } from 'src/app/shared/components/empty.component';
import { CanDeactivateGuard } from 'src/app/shared/helpers/canDeactivate';
import { CourseDisplayerComponent } from './course-displayer/course-displayer.component';
import { CoursesListComponent } from './courses-list/courses-list.component';
import { firstLectureRedirectGuard } from './first-lecture-redirect.guard';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);

export const CoursesRoutes: Routes = [
  { path: '', redirectTo: 'list', pathMatch: 'full' },

  {
    path: 'list',
    component: CoursesListComponent,
    canActivate: [AuthGuard],
    data: {
      authGuardPipe: redirectUnauthorizedToLogin,
    },
  },

  {
    path: 'displayer/:course/:section/:lecture',
    component: CourseDisplayerComponent,
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
    data: {
      authGuardPipe: redirectUnauthorizedToLogin,
    },
  },

  {
    path: 'overview/:course',
    component: EmptyComponent,
    canActivate: [AuthGuard, firstLectureRedirectGuard],
    data: {
      authGuardPipe: redirectUnauthorizedToLogin,
    },
  },
];
